import { Interpolation } from "@emotion/serialize";
import type { InterpolationWithTheme } from "@emotion/core/types";
import { Theme } from "@emotion/react";

import { ICandyTheme } from "./CandyTheme/ThemeBuilder/ICandyTheme";

declare module "@emotion/react" {
    export interface Theme {
        candy: ICandyTheme;
    }
}

export function themed(...items: Array<Interpolation<Theme>>): InterpolationWithTheme<Theme> {
    // @ts-ignore
    return items;
}
